/**
 * ITDS Icon groups
 * {@link} https://www.figma.com/design/WOSWwiLtSxupJFmOHbwAHw/%E2%AD%90-Icons---Interticket-Design-Language?node-id=1-5200&m=dev
 */
export enum ITDSIconGroup {
  COMMERCE = 'Commerce',
  CONTROLS = 'Controls',
  DATA = 'Data',
  EVENT_TYPE = 'Event type',
  FILES = 'Files',
  FORMATTING = 'Formatting',
  NAVIGATION = 'Navigation',
  OPERATION = 'Operation',
  OTHER = 'Other',
  SMART_CITY = 'Smart city',
  SOCIAL_MEDIA = 'Social media',
  STATUS = 'Status',
  TECHNOLOGY = 'Technology',
  TICKETING = 'Ticketing',
  TIME_ICONS = 'Time icons',
  TOGGLE_ICONS = 'ToggleIcons',
  USER = 'User',
  WEATHER = 'Weather',
}
